var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logout d-flex justify-content-center"},[_c('h4',[_vm._v("Logging you out ...")])])
}]

export { render, staticRenderFns }